import React from 'react';
import {ISupplierUserProfile, IFdFarmAssetType} from 'constants/interfaces';
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from '@material-ui/core';
import {reduxToggleSidePanel} from 'appredux/actions';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {ESidePanelView} from 'constants/index';
import {AssetSidePanelData} from 'screens/Dashboard/utils/SidePanel/SidePanel';

const EditFdAssets = (props: {
  user: ISupplierUserProfile;
  applicationId: number;
  farmId: number;
  assets: IFdFarmAssetType[];
  onAssetUpserted?: () => void;
}) => {
  const handleEdit = (asset: IFdFarmAssetType) => {
    const type = {
      panelType: ESidePanelView.EDIT_FD_ASSET,
      data: {
        applicationId: props.applicationId,
        farmId: props.farmId,
        asset: asset,
        onAssetUpserted: props.onAssetUpserted,
      } as AssetSidePanelData,
    };
    reduxToggleSidePanel(true, type, false);
  };

  const handleAdd = () => {
    const type = {
      panelType: ESidePanelView.EDIT_FD_ASSET,
      data: {
        applicationId: props.applicationId,
        farmId: props.farmId,
        onAssetUpserted: props.onAssetUpserted,
      } as AssetSidePanelData,
    };
    reduxToggleSidePanel(true, type, false);
  };

  return (
    <Box margin={'1rem'}>
      <Box marginLeft={1}>
        <Typography variant="subtitle2" gutterBottom>
          Assets
        </Typography>
      </Box>
      <List>
        {props.assets
          .sort((a, b) => a!.description!.localeCompare(b!.description!))
          .map((asset) => (
            <ListItem key={asset.id} button onClick={() => handleEdit(asset)}>
              <Box display="flex" justifyContent="space-between" width="100%">
                <ListItemText
                  primary={`${asset.description} (${
                    asset.assetListItem!.name
                  })`}
                />
                <ListItemSecondaryAction>
                  <ChevronRightIcon />
                </ListItemSecondaryAction>
              </Box>
            </ListItem>
          ))}
      </List>
      <Button variant="text" fullWidth onClick={handleAdd} color={'primary'}>
        Add
      </Button>
    </Box>
  );
};

export default EditFdAssets;
